import { Platform, PlatformIOSStatic } from "react-native";
import { isTablet, isDesktop } from "react-device-detect";

export const deviceIdentifier = () => {
  const OS = Platform.OS;

  let type = "n/a";

  if (Platform.OS === "ios") {
    const platformIOS = Platform as PlatformIOSStatic;
    if (platformIOS.isPad) {
      type = "Tablet";
    } else {
      type = "Phone";
    }
  }

  if (Platform.OS === "android") {
    if (isTablet) {
      type = "Tablet";
    } else {
      type = "Phone";
    }
  }

  if (Platform.OS === "web") {
    if (isDesktop && !isTablet) {
      type = "Desktop";
    } else if (isTablet) {
      type = "Tablet";
    } else {
      type = "Phone";
    }
  }

  return `${OS}${type}`;
};

export const domusoResponsiveStyleHelper = (styles: any) => {
  const currentDevice = deviceIdentifier();
  let styleToReturn = {};

  if (currentDevice in styles) {
    styleToReturn = styles[currentDevice];
  }

  return styleToReturn;
};
